import React from 'react';

interface ContainersIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export const ContainersIcon: React.FC<ContainersIconProps> = ({ size = 20, ...props }) => {
  return (
    <svg
      fill="none"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      height={size}
      width={size}
    >
      <g clipRule="evenodd" fill="#B5BCC4" fillRule="evenodd">
        <path d="M5.948 5.615c.408 0 .738.33.738.738v7.294a.738.738 0 0 1-1.476 0V6.353c0-.408.33-.738.738-.738ZM14.05 5.615c.408 0 .739.33.739.738v7.294a.738.738 0 0 1-1.477 0V6.353c0-.408.33-.738.739-.738ZM10 5.615c.407 0 .738.33.738.738v7.294a.738.738 0 1 1-1.477 0V6.353c0-.408.33-.738.738-.738Z" />
        <path d="M1.666 4.937A2.426 2.426 0 0 1 4.092 2.51h11.814a2.426 2.426 0 0 1 2.427 2.426v10.126a2.426 2.426 0 0 1-2.426 2.426H4.091a2.426 2.426 0 0 1-2.426-2.426V4.937Zm2.426-.95a.95.95 0 0 0-.95.95v10.126c0 .525.426.95.95.95h11.814a.95.95 0 0 0 .95-.95V4.937a.95.95 0 0 0-.95-.95H4.092Z" />
      </g>
    </svg>
  );
};
